import { render, staticRenderFns } from "./RankPopup.vue?vue&type=template&id=6d7a4978&scoped=true&"
import script from "./RankPopup.vue?vue&type=script&lang=js&"
export * from "./RankPopup.vue?vue&type=script&lang=js&"
import style0 from "./RankPopup.vue?vue&type=style&index=0&id=6d7a4978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a4978",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
